import axios from 'axios'
import queryString from 'query-string'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import {
  VirtualCardsFiltersBody,
  VirtualCardsResponse,
} from 'src/queries/virtualCards.models'

export const getVirtualCards = async ({
  filters,
  page,
  count,
}: {
  filters: VirtualCardsFiltersBody | undefined
  page: number
  count: number
}): Promise<VirtualCardsResponse> => {
  return getResponseData(
    axios.get<VirtualCardsResponse>(
      `virtualcards?${queryString.stringify({ ...filters, page, count })}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
